<div class="file-dnd-container" fxLayout="column" fxLayoutGap="8px" appDnd (fileDropped)="onFilesSelect($event)">
  <div
    class="dropzone"
    fxLayout="column" fxFlex="100" fxLayoutGap="15px"
    (click)="openFileSelect()"
  >
    <input [accept]="acceptMime" type="file" hidden #fileDropRef id="fileDropRef" [multiple]="multiple" (change)="onFilesSelect($any($event.target).files)"/>
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center">
      <mat-icon>cloud_upload</mat-icon>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center">
      Upuść tutaj pliki lub kliknij aby przeglądać (max {{maxSize/1024/1024 | number:'1.0-2'}} MB)
    </div>
  </div>

  <div class="file" *ngFor="let selectedFile of selectedFiles; let index = index" fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <div class="name" fxLayout="row" fxFlex="55">
      <button mat-icon-button><mat-icon>description</mat-icon></button>
      <div>
        <div class="file-name">{{selectedFile.name}}</div>
        <div class="file-size">{{selectedFile.size/1024/1024 | number:'1.0-2'}} MB</div>
<!--        <div class="file-name" *ngIf="fileResults?.hasOwnProperty(index) && fileResults[index].result === false && fileResults[index].error">{{ fileResults[index].error }}</div>-->
      </div>
    </div>
    <span fxFlex></span>

    <div class="name"   fxFlex="30">
      <div class="file-name" *ngIf="fileResults?.hasOwnProperty(index) && fileResults[index].result === false" > {{ fileResults[index].error }}</div>
    </div>
    <div *ngIf="fileResults?.hasOwnProperty(index) && fileResults[index].result === true" fxFlex="10">
      <button mat-icon-button (click)="open(fileResults[index].uuid)"><mat-icon class="positive-icon">check_circle</mat-icon> Podgląd</button>
    </div>
    <div *ngIf="fileResults?.hasOwnProperty(index) && fileResults[index].result === false" fxFlex="10">
      <button mat-icon-button ><mat-icon class="negative-icon">cancel</mat-icon> </button>
    </div>
<!--    <div *ngIf="fileResults?.hasOwnProperty(index) && fileResults[index].result === false" fxFlex="10">-->
<!--      <button mat-icon-button (click)="open(fileResults[index].uuid)"><mat-icon class="negative-icon">cancel</mat-icon> Edytuj</button>-->
<!--    </div>-->
    <div fxFlex="5">
      <button mat-icon-button color="warn" (click)="unselectFile(index, fileResults[index].uuid)"><mat-icon>delete</mat-icon></button>
    </div>
  </div>
</div>
